import React from "react";
import { abbreviateNumber } from "js-abbreviation-number";
import { Link } from "react-router-dom";
import slugify from "../utils/slugify";
import LazyImage from "./LazyImage";
import VideoLength from "../shared/VideoLength";

const VideoCard = ({ video, compact = false }) => {
  const slug = slugify(video?.title || video?.videoId || "video");
  return (
    // pass the full video object into route state so VideoDetails can play deep-search items
    <Link to={`/${slug}`} state={{ playerVideo: video }}>
      <div className={`flex flex-col ${compact ? 'mb-2' : 'mb-8'}`}>
  <div className={`relative ${compact ? 'h-24' : 'h-48 md:h-40'} rounded-xl overflow-hidden`}>
          <LazyImage
            src={video?.thumbnails?.[0]?.url || '/default-thumbnail.svg'}
            alt={video?.title || 'thumbnails'}
            className="h-full w-full object-cover"
            videoUrl={video?.originalUrl || video?.url}
            videoDuration={video?.lengthSeconds}
          />
          {video?.lengthSeconds && <VideoLength time={video?.lengthSeconds} />}
        </div>

        <div className="flex text-black dark:text-white mt-3">
          <div className="flex flex-col overflow-hidden">
            <span className={`font-bold line-clamp-2 whitespace-normal break-words ${compact ? 'text-xs' : 'text-sm md:text-base lg:text-lg'}`}>
              {video?.title}
            </span>

            <div className={`font-semibold truncate overflow-hidden ${compact ? 'text-[10px]' : 'text-[12px]'} text-black/[0.7] dark:text-white/[0.7]`}>
              <span>{`${abbreviateNumber(video?.stats?.views, 2)} views`}</span>
              <span className={`text-black/[0.7] dark:text-white/[0.7] font-bold leading-none relative top-[-10px] mx-1 ${compact ? 'text-[18px]' : 'text-[24px]'}`}>
                .
              </span>
              <span className="truncate">{video?.publishedTimeText}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default VideoCard;
